var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategory8 = function SvgCategory8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "category8_svg__w-full category8_svg__h-full",
    viewBox: "0 0 64 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#727277",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    clipPath: "url(#category8_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.516 55.16H16.474L.96 27.995 16.474.844h31.042L63.03 27.996 47.516 55.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 13.96c-7.659 0-13.89 6.297-13.89 14.035S24.341 42.03 32 42.03s13.89-6.296 13.89-14.034S39.659 13.961 32 13.961Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "category8_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v56H0z"
  })))));
};
export default SvgCategory8;